import { render, staticRenderFns } from "./ConfirmacaoEmail.vue?vue&type=template&id=45d5e81d&scoped=true&"
import script from "./ConfirmacaoEmail.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoEmail.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmacaoEmail.vue?vue&type=style&index=0&id=45d5e81d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d5e81d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VIcon,VRow,VTextField})
